import { notificationsActionTypes, orderNotifications } from '@/components/notifications/Constants';

import type { NotificationsAction } from '@/components/notifications/Actions';
import type { NotificationsState } from '@/components/notifications/types';

const initialState: NotificationsState = {
	loading: true,
	open: false,
	recentNotifications: [],
	oldNotifications: [],
	notifications: [],
	page: 1,
	perPage: 10,
	total: 0,
};

export default function notificationsReducer(
	state = initialState,
	action: NotificationsAction,
): NotificationsState {
	const { type } = action;

	switch (type) {
		case notificationsActionTypes.TOGGLE_NOTIFICATIONS_MENU:
			return {
				...initialState,
				open: action.payload.status,
			};

		case notificationsActionTypes.GET_NOTIFICATIONS_REQUEST:
			return {
				...state,
				loading: true,
			};

		case notificationsActionTypes.GET_NOTIFICATIONS_SUCCESS: {
			const notifications = orderNotifications(
				action.payload.notificationsData.notifications,
				'created_at',
				'desc',
			);

			return {
				...state,
				loading: false,
				recentNotifications: [
					...state.recentNotifications,
					...notifications.filter((notification) => notification.is_recent),
				],
				oldNotifications: [
					...state.oldNotifications,
					...notifications.filter((notification) => !notification.is_recent),
				],
				notifications: [...state.notifications, ...notifications],
				page: state.page + 1,
				total: action.payload.notificationsData.total_count,
			};
		}

		case notificationsActionTypes.GET_NOTIFICATIONS_ERROR:
			return {
				...state,
				loading: false,
				open: false,
			};

		case notificationsActionTypes.UPDATE_NOTIFICATION_STATUS_ERROR:
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
}
